import * as React from "react";
import { SVGProps } from "react";

const Star = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 .907a.75.75 0 0 1 .672.418l3.059 6.197 6.838.994a.75.75 0 0 1 .416 1.279l-4.949 4.823 1.169 6.811a.75.75 0 0 1-1.089.791L12 19.004 5.883 22.22a.75.75 0 0 1-1.088-.79l1.168-6.812-4.948-4.823a.75.75 0 0 1 .415-1.28l6.839-.993 3.058-6.197A.75.75 0 0 1 12 .907Zm0 2.445L9.44 8.539a.75.75 0 0 1-.565.41l-5.725.832 4.142 4.038a.75.75 0 0 1 .216.664l-.978 5.702 5.12-2.692a.75.75 0 0 1 .699 0l5.12 2.692-.978-5.702a.75.75 0 0 1 .216-.664l4.143-4.038-5.725-.831a.75.75 0 0 1-.565-.41L12 3.351Z"
    />
  </svg>
);

export default Star;
